import { apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { CapitalAdequacy } from '../types';

export const capitalAdequacyApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCapitalAdequacyReport: build.query<{ data: CapitalAdequacy }, string>({
      query: (query) => ({
        url: `/v1/reports/capital-adequacy${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),

    exportCapitalAdequacyReport: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/capital-adequacy/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportCapitalAdequacyReportWithAccoubts: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/capital-adequacy/accounts/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetCapitalAdequacyReportQuery,
  useExportCapitalAdequacyReportMutation,
  useExportCapitalAdequacyReportWithAccoubtsMutation,
} = capitalAdequacyApi;

export const {
  endpoints: {
    getCapitalAdequacyReport,
    exportCapitalAdequacyReport,
    exportCapitalAdequacyReportWithAccoubts,
  },
} = capitalAdequacyApi;
